// https://www.lichter.io/articles/nuxt3-vue3-dynamic-images/#the-importmetaglob-trick
import { filename } from 'pathe/utils'

export const getDynamicAssetsMap = (importMap: Record<string, unknown>) => Object.fromEntries(
  Object.entries(importMap).map(([key, value]) => [filename(key), value && typeof value === 'object' && 'default' in value ? value.default : undefined]),
)
